import { Year } from '../../types'
import { fetchYears } from '../../services/years.service'
import createBaseStore from '../createStoreHelper'
import { getters } from './year.getters'

export const YearModule = createBaseStore<Year>({
  resourceName: 'year',
  apiCalls: {
    fetchAllApiCall: fetchYears
  }
})

YearModule.getters = { ...YearModule.getters, ...getters }
